module.exports = __webpack_public_path__ + "img/private-pizzeriano3-pizzas-2.cda9eea9.jpg";